module.exports = __webpack_public_path__ + "img/Pattern02.0a38e7cb.png";